import { NgIf } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-info-tooltip',
    templateUrl: './info-tooltip.component.html',
    styleUrls: ['./info-tooltip.component.scss'],
    imports: [NgIf]
})
export class InfoTooltipComponent implements OnInit {
  @Input() htmlTooltip = '';
  @Input() tooltipKey = '';

  show = false;

  ngOnInit() {
    if (this.tooltipKey) {
      const shownTooltips = JSON.parse(localStorage.getItem('shownTooltips') || '{}');
      const isDashboardGuideShown = localStorage.getItem('dashboardGuideShown');
      if (!shownTooltips[this.tooltipKey] && isDashboardGuideShown) {
        this.show = true;
        shownTooltips[this.tooltipKey] = true;
        localStorage.setItem('shownTooltips', JSON.stringify(shownTooltips));
      }
    }
  }

  toggleTooltip(event?: Event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.show = !this.show;
  }

  showTooltip() {
    this.show = true;
  }

  hideTooltip(event?: Event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.show = false;
  }

  static resetAllTooltips() {
    localStorage.removeItem('shownTooltips');
  }
}
